import { Icon, Label, Segment } from "semantic-ui-react";

import React from "react";

import Flex from "astrid-components/lib/components/Layout/Flex";

import truncateString from "../../../ui/utils/truncateString";

import { useProfile } from "../../../authentication/state/profile";

import { setDiscussion } from "../../state/discussion";

import DiscussionChannelUserImages from "./components/DiscussionChannelUserImages";

export default function DiscussionChannelListItem({ channel, showProductionName }) {
	const user = useProfile();

	const { users, name, subject, lastComment } = channel;

	const isUnseen = !channel.seenByUserIds?.includes(user.id);

	const lastCommentSender = lastComment?.sender?.ref.path.includes("users") && lastComment.sender.name.split(" ")[0];

	function capitalizeFirstLetter(name) {
		return String(name).charAt(0).toUpperCase() + String(name).slice(1);
	}

	return (
		<Segment
			vertical
			style={{ padding: 15, cursor: "pointer" }}
			onClick={() => setDiscussion({ isOpen: true, channelId: channel.id })}
			className="discussionsFeedListItem"
		>
			<Flex>
				<Flex gap={10}>
					<DiscussionChannelUserImages users={users} />

					<div>
						<div style={{ margin: 0, opacity: 0.6 }}>
							{showProductionName && `${truncateString(subject?.name, 15)} /`}

							<Icon name="hashtag" style={{ opacity: 0.4, fontSize: "0.9em", marginRight: 2 }} />

							{capitalizeFirstLetter(name)}
						</div>

						{lastCommentSender && (
							<div
								style={{ overflow: "hidden", color: "var(--color-text)" }}
							>{`${lastCommentSender}: ${truncateString(lastComment.text, 35)}`}</div>
						)}
					</div>
				</Flex>

				{isUnseen && <Label circular empty color="blue" size="tiny" />}
			</Flex>
		</Segment>
	);
}
